import { useAppSelector } from '../../store/hooks';

export const useIsDev = () => {
  const { tenantAndProject } = useAppSelector(({ endUser }) => endUser);

  const isDev =
    tenantAndProject?.domain === 'dev.hvm.impltech.online' &&
    tenantAndProject?.id === 11486;

  return isDev;
};
